import PropTypes from "prop-types";
import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import { IPFormSchema } from "../../../../utils/validation";
import Button from "../../../Button/Button";
import FormInput2 from "../../../FormInput/FormInput2";
import Rodal from "rodal";
import ModalInput from "../../../FormInput/ModalInput";
import Rejected from "../Nip-PublicKeys/Rejected";
import Storage from "../../../../utils/storage";

export const dataSet = (values) => {
  return {
    ip: values.ip_address,
    production_ip: values.ip_address,
  };
}

export const handleSubmissionFunc = (setState, values, checked, goToNext, showPop) => {
  setState({
    values: values,
  });
  if (checked) {
    const data = dataSet(values);
    goToNext(data);
  } else {
    showPop();
  }

  return checked;
}

export const submitValuesFunc = (state, values, goToNext, setPopUp) => {
  const newValues = {
    ip: state.values.ip_address,
    production_ip: values.production_ip,
  };
  setPopUp(false);
  goToNext(newValues);
  
  return values;
};

const NipForm = (props) => {
  const { goToNext, application, isSubmitting, submitApplication } = props;

  const [checked, setChecked] = useState(false);
  const [popUp, setPopUp] = useState(false);
  const [showAlert, setShowAlert] = useState(true);

  let userStatus = Storage.get("user-access-data");
  const user = JSON.parse(userStatus);
  let userType = user && user.type;

  const trail = application && application.nip_trail;
  const permitStatus =
    application &&
    application.ip_permit_info &&
    application.ip_permit_info.ip_permit_status;

  const [state, setState] = useState({
    production_ip: "",
    values: "",
  });

  const initialValues = {
    ip_address: "",
  };

  const showPop = () => {
    setPopUp(true);
  };

  const handleSubmission = (values) => {
    handleSubmissionFunc(setState, values, checked, goToNext, showPop)
  };

  const submitValues = (values) => {
    submitValuesFunc(state, values, goToNext, setPopUp)
  };

  return (
    <div className="nip-permit-form-div">
      {!trail.ip_form_submission && !trail.ip_permit_approval && !permitStatus && (
        <div>
          <div className="nip-integration-header">IP FORM</div>
          <div>
            <Formik
              initialValues={initialValues}
              validationSchema={IPFormSchema}
              onSubmit={handleSubmission}
            >
              {({ values, isValid, dirty }) => {
                const block = values.ip_address === "";
                return (
                  <Form id="form">
                    <div className="nip-form-sec">
                      <div className="form-input">
                        <Field
                          name="ip_address"
                          label="Please provide IP address of your NIP Endpoint"
                          placeholder="Enter IP address"
                          component={FormInput2}
                        />
                      </div>

                      <div className="check-sec">
                        <input
                          className="check-box"
                          type="checkbox"
                          id="nip-check"
                          data-testid="setChecked"
                          onChange={() => setChecked(!checked)}
                        />
                        <label
                          htmlFor="nip-check"
                          className="checkbox-custom-label"
                        >
                          <p className="agree">
                            I want to use the same IP for production
                          </p>
                        </label>
                      </div>

                      <div className="nip-form-sec-button">
                        <Button
                          type="submit"
                          width="45%"
                          height="45px"
                          word={"Proceed"}
                          disabled={block || !(isValid && dirty)}
                        />
                      </div>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </div>
      )}

      {permitStatus === "rejected" &&
        !trail.ip_form_submission &&
        !trail.ip_permit_approval ? (
          <div className="nip-permit-form">
            <Rejected
              showAlert={showAlert}
              setShowAlert={() => setShowAlert(false)}
              application={application}
              goToNext={goToNext}
              isSubmitting={isSubmitting}
              submitApplication={submitApplication}
              userType={userType}
            />
          </div>
        ) : (
          <div></div>
        )}

      <Rodal width={Number("520")} height={Number("450")} visible={popUp}>
        <div>
          <div className="modal-header4">
            <h1>PRODUCTION IP</h1>
          </div>

          <div className="side-acct">
            <div className="side-acct-info">
              Please NOTE that any IP your supply here is what would be used at
              production and can’t be changed.
            </div>
          </div>

          <div>
            <Formik
              initialValues={{
                production_ip: "",
              }}
              onSubmit={(values) => {
                submitValues(values);
              }}
            >
              {({ values, isValid, dirty }) => {
                const block = values.production_ip === "";

                return (
                  <Form id="production">
                    <div className="modal-form2">
                      <div className="form-grid">
                        <Field
                          name="production_ip"
                          label="Production IP"
                          placeholder="Enter production IP"
                          component={ModalInput}
                        />
                      </div>

                      <div className="form-grid-4">
                        <div className="modal-input-button">
                          <button
                            className="modal-close-button"
                            onClick={() => setPopUp(false)}
                            type="button"
                            data-testid="cancelForm"
                          >
                            CANCEL
                          </button>
                        </div>

                        <div className="modal-input-button">
                          <button
                            type="submit"
                            className="modal-action-button"
                            disabled={block}
                            data-testid="submitForm"
                          >
                            PROCEED
                          </button>
                        </div>
                      </div>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </div>
      </Rodal>
    </div>
  );
};

NipForm.propTypes = {
  application: PropTypes.shape({
    ip_permit_info: PropTypes.shape({
      ip_permit_status: PropTypes.any
    }),
    nip_trail: PropTypes.any
  }),
  goToNext: PropTypes.func,
  isSubmitting: PropTypes.any,
  submitApplication: PropTypes.any
}

export default NipForm;
